import { render, staticRenderFns } from "./PriceSurchargeModal.vue?vue&type=template&id=e6e5ff86&scoped=true&"
import script from "./PriceSurchargeModal.vue?vue&type=script&lang=ts&"
export * from "./PriceSurchargeModal.vue?vue&type=script&lang=ts&"
import style0 from "./PriceSurchargeModal.vue?vue&type=style&index=0&id=e6e5ff86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e5ff86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
